import * as React from 'react';
import {
  Button,
  PageSection,
  Title
} from '@patternfly/react-core';
import { SUPPORT_EMAIL, PRODUCT_NAME } from '../../config/partner';

export interface ISupportProps {
  sampleProp?: string;
}

// eslint-disable-next-line prefer-const
let Support: React.FunctionComponent<ISupportProps> = () => (
  <PageSection hasBodyWrapper={false}>
    <Title headingLevel="h1" size="xl">{PRODUCT_NAME} Documentation</Title>

      <p>Please find documentation below for how the {PRODUCT_NAME} service works.</p>
      <p>The process is designed to be quick and simple, giving you actionable intelligence as quickly as possible.</p>

    <Title headingLevel="h2">1 - Integration & Permissions <i className="pf-icon fa-download"></i></Title>

      <p>First, {PRODUCT_NAME} needs to be provisioned access to the relevant environment to collect data.</p>
      <p>Click the relevant link on the home page to start to provision access.  NB: Some sources need manual steps, we will send you an email with details.</p>

    <Title headingLevel="h2" >2 - Collection & Analysis</Title>

      <p>Once access is provisioned, {PRODUCT_NAME} will collect and analyze data.  This process may take up to 12 hours.</p>

    <Title headingLevel="h2" >3 - Reporting</Title>

      <p>Within 24 hours, one of the team will contact you with your report.</p>

    <Title headingLevel="h2" >4 - Next Steps</Title>

      <p>When we get in contact with your report, we will offer next steps.</p>
      <p>Note: We will provide a special link to remove {PRODUCT_NAME} from your environments after your check is complete.</p>

      <p>If you need any further assistance just <Button variant="primary" component="a" href={`mailto:${SUPPORT_EMAIL}?subject=${PRODUCT_NAME} support`} >Contact Support</Button></p>

  </PageSection>
);

export { Support };
